import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { StageController } from "../Components/StageController";
import { Communication } from "neo-games";
import { BaseView } from "../GameComponents/Base/BaseView";
import { Symbol } from "../GameComponents/Symbol";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { PlayList } from "../Components/Sounds/PlayList";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimator2 extends WinAnimator {
    public static Force: boolean = false;

    private static DynamicTints: Array<string> = [
        "0083ff",
        "ff2323",
        "00fd4d",
        "ffde00",
        "cc00b5",
        "8fff00",
        "ff4100",
        "00eaff",
        "bd9200",
        "ff4dba",
    ];

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        super.onReelStopped(reelsData, reelIndex);

        // if (!WinAnimator2.Force) {
        this.impactSpecialSymbols(reelsData, reelIndex);
        // }

        for (let i = 0; i <= reelIndex; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                if (this.currentSymbols[i][j] != null) {
                    this.currentSymbols[i][j].alpha = 1;
                }
            }
        }
    }

    //******************************************************************************************************************
    //  CYCLE WINS
    //******************************************************************************************************************

    protected cycleWins(): void {
        if (this.currentWins == null) {
            return;
        }

        //skip freespin cycle win
        if (this.currentWins[this.currentCycle].type === Communication.Game.WinType.freeSpins) {
            this.currentCycle = (this.currentCycle + 1) % this.currentWins.length;
            this.cycleWins();

            return;
        }

        super.cycleWins();
    }

    public showWins(wins: Array<Communication.Game.IWin>, win: number): boolean {
        let result = super.showWins(wins, win);

        this.setDynamicTint();

        return result;
    }

    protected impactSpecialSymbols(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        const symbolIndex = this.currentReels[reelIndex].symbols.indexOf(13);

        if (symbolIndex != null && this.currentSymbols[reelIndex][symbolIndex] != null) {
            let countScatters = this.countScatters(reelIndex);

            switch (reelIndex) {
                case 0:
                    if (countScatters === 1) {
                        (StageController.baseStageContainer as BaseView).shock1(
                            this.currentSymbols[reelIndex][symbolIndex].x + this.symbolWidth / 2,
                            this.currentSymbols[reelIndex][symbolIndex].y + this.symbolHeight / 2,
                            60,
                        );
                        PlayList.play("SND_BaseBonusHit" + ((countScatters - 1) % 2) + "_" + reelIndex);
                    }
                    break;
                case 1:
                    if (countScatters >= 1) {
                        (StageController.baseStageContainer as BaseView).shock2(
                            this.currentSymbols[reelIndex][symbolIndex].x + this.symbolWidth / 2,
                            this.currentSymbols[reelIndex][symbolIndex].y + this.symbolHeight / 2,
                            60,
                        );
                        PlayList.play("SND_BaseBonusHit" + ((countScatters - 1) % 2) + "_" + reelIndex);
                    }
                    break;
                case 2:
                    if (countScatters >= 1) {
                        (StageController.baseStageContainer as BaseView).shock3(
                            this.currentSymbols[reelIndex][symbolIndex].x + this.symbolWidth / 2,
                            this.currentSymbols[reelIndex][symbolIndex].y + this.symbolHeight / 2,
                            60,
                        );
                        PlayList.play("SND_BaseBonusHit" + ((countScatters - 1) % 2) + "_" + reelIndex);
                    }
                    break;
                case 3:
                    if (countScatters >= 1) {
                        (StageController.baseStageContainer as BaseView).shock4(
                            this.currentSymbols[reelIndex][symbolIndex].x + this.symbolWidth / 2,
                            this.currentSymbols[reelIndex][symbolIndex].y + this.symbolHeight / 2,
                            60,
                        );
                        PlayList.play("SND_BaseBonusHit" + ((countScatters - 1) % 2) + "_" + reelIndex);
                    }
                    break;
                case 4:
                    if (countScatters > 1) {
                        (StageController.baseStageContainer as BaseView).shock5(
                            this.currentSymbols[reelIndex][symbolIndex].x + this.symbolWidth / 2,
                            this.currentSymbols[reelIndex][symbolIndex].y + this.symbolHeight / 2,
                            60,
                        );
                        PlayList.play("SND_BaseBonusHit" + ((countScatters - 1) % 2) + "_" + reelIndex);
                    }
                    break;
            }
        }

        if (this.countScatters(reelIndex) >= 2) {
            for (let i = 0; i <= reelIndex; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseNowin)) {
                        if (this.currentSymbols[i][j].id !== 12) {
                            this.currentSymbols[i][j].goToCase(Symbol.CaseNowin);
                        }
                    }
                }
            }
        }

        if (reelIndex === 4 && this.countScatters(reelIndex) <= 2) {
            for (let i = 0; i <= reelIndex; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseNormal)) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                    }
                }
            }
        }
    }

    protected countScatters(reelIndex: number): number {
        let count = 0;

        for (let i = 0; i <= reelIndex; i++) {
            if (this.currentReels[i].symbols.indexOf(13) !== -1) {
                count++;
            }
        }

        return count;
    }

    private setDynamicTint(): void {
        let paylineId = 0;
        let currentMax = 0;

        for (let i = 0; i < this.currentWins.length; i++) {
            if (this.currentWins[i].trigger == Communication.Game.WinTrigger.Scatter) {
                paylineId = 10;
                break;
            }

            if (this.currentWins[i].amount > currentMax) {
                currentMax = this.currentWins[i].amount;
                paylineId = this.currentWins[i].paylineId;
            }
        }

        ImageElement.DynamicTint = WinAnimator2.DynamicTints[paylineId - 1];
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimator2.ts
 **/